import React, { useState } from 'react';
import SymptomForm from './routes/SymptomForm.js';
import { HashRouter, Route, Routes } from 'react-router-dom'
import Report from './routes/report.js';
import Outcome from './routes/outcome.js';
import './css/App.css'


function App(props) {

  const [formData, setFormData] = useState();
  const [outcomeData,setOutcomeData] = useState()
  const [melanomaSevenPoint, setMelanomaSevenPoint]= useState() //picks up inputs from mealnoma modal and which are sent down to story component
  const [idaValues, setIdaValues]= useState() //as above but for IDA modal 
 
  return (
    <HashRouter>
      <Routes> {/* The Switch decides which component to show based on the current URL.*/}
        <Route exact path='/' element={< SymptomForm setFormData={setFormData} setMelanomaSevenPoint={setMelanomaSevenPoint} setIdaValues={setIdaValues}/>}></Route>
        <Route exact path='/Report' element={<Report formData={formData}  setOutcomeData={setOutcomeData}melanomaSevenPoint={melanomaSevenPoint} idaValues={idaValues}/> }></Route>
        <Route exact path='/Outcome' element={<Outcome outcomeData={outcomeData} />}></Route>
      </Routes>
    </HashRouter>)
}

export default App
